// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2cKeL","search":"Settings_search__7EXbL","filter":"Settings_filter__3nsT2"};